import { request, type ApiResult } from '../../lib/apiClient';

/**
 * Upload a local file to Bunny via signed direct PUT (Workers-safe).
 */
export async function uploadFile(file: File): Promise<ApiResult<{ url: string; path: string }>> {
  const signed = await request<{
    token: string;
    path: string;
    uploadUrl: string;
    maxBytes: number;
  }>('/api/uploads/sign', {
    method: 'POST',
    body: JSON.stringify({
      filename: file.name || 'upload.bin',
      contentType: file.type || 'application/octet-stream',
    }),
  });

  if (signed.error) return { data: null, error: signed.error };

  if (file.size > signed.data.maxBytes) {
    return {
      data: null,
      error: {
        code: 'too_large',
        message: `File is too large (max ${Math.round(signed.data.maxBytes / (1024 * 1024))}MB).`,
        status: 413,
      },
    };
  }

  const uploadPath = signed.data.uploadUrl.startsWith('/')
    ? signed.data.uploadUrl
    : `/api/uploads/direct/${signed.data.token}`;

  return request<{ url: string; path: string }>(uploadPath, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
    },
    body: file,
  });
}
